"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    isCloudLocale: ()=>isCloudLocale,
    defaultCloudLocale: ()=>defaultCloudLocale,
    normalLocaleToCloudLocale: ()=>normalLocaleToCloudLocale,
    cloudLocaleToNormalLocale: ()=>cloudLocaleToNormalLocale,
    saveCloudLocale: ()=>saveCloudLocale
});
const external_init_config_js_namespaceObject = require("../init-config.js");
const cloudLocaleMap = {
    zh: 'zh-CN',
    en: 'en-US'
};
const isCloudLocale = (locale)=>'zh' === locale || 'en' === locale;
const localeLocalStorageKey = 'cloud-locale';
const cloudLocaleToNormalLocale = (cloudLocale)=>cloudLocaleMap[cloudLocale] || cloudLocaleMap.zh;
const normalLocaleToCloudLocale = (normalLocale)=>{
    const target = Object.keys(cloudLocaleMap).find((key)=>{
        cloudLocaleMap[key];
    });
    return target || 'zh';
};
const getStorageLocale = ()=>{
    try {
        const result = window.localStorage.getItem(localeLocalStorageKey) || window.sessionStorage.getItem((0, external_init_config_js_namespaceObject.getSessionStorageKey)('cloudLocale'));
        if (isCloudLocale(result)) return result;
    } catch (error) {
        console.error(error);
    }
};
const getBrowserLocale = ()=>{
    try {
        return navigator.language.startsWith('zh') ? 'zh' : 'en';
    } catch (error) {
        return 'en';
    }
};
let defaultCloudLocale = getStorageLocale() || getBrowserLocale();
const saveCloudLocale = (locale)=>{
    try {
        if (isCloudLocale(locale)) {
            window.localStorage.setItem(localeLocalStorageKey, locale);
            defaultCloudLocale = locale;
        }
    } catch (error) {
        console.error(error);
    }
};
exports.cloudLocaleToNormalLocale = __webpack_exports__.cloudLocaleToNormalLocale;
exports.defaultCloudLocale = __webpack_exports__.defaultCloudLocale;
exports.isCloudLocale = __webpack_exports__.isCloudLocale;
exports.normalLocaleToCloudLocale = __webpack_exports__.normalLocaleToCloudLocale;
exports.saveCloudLocale = __webpack_exports__.saveCloudLocale;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "cloudLocaleToNormalLocale",
    "defaultCloudLocale",
    "isCloudLocale",
    "normalLocaleToCloudLocale",
    "saveCloudLocale"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
